const formatPostcode = postcode => {
  if (postcode) {
    // Removes any spacing from the postcode
    const clearPostcodeSpacing = postcode.replace(/\s/g, '')
    return `${clearPostcodeSpacing.slice(0, clearPostcodeSpacing.length - 3)} ${clearPostcodeSpacing.slice(-3)}`
  }

  return ''
}

export default formatPostcode

// N13LD -> N1 3LD
// GL509TY -> GL50 9TY
// EC1 -> EC1
// TF3   1XQ -> TF3 1XQ
// TF 31XQ -> TF3 1XQ
// DN551PT -> DN55 1PT
